import { type RefObject, useEffect, useState } from "react";

export function useElementHeight<T extends HTMLElement>(ref: RefObject<T | null>) {
	const [height, setHeight] = useState<number>(0);

	useEffect(() => {
		const el = ref.current;
		if (!el) return;
		setHeight(el.offsetHeight);
		const ro = new ResizeObserver((entries) => {
			for (const entry of entries) {
				// Use offsetHeight (border-box) instead of contentRect (content-box),
				// so callers using this for layout offsets account for padding/borders.
				setHeight((entry.target as HTMLElement).offsetHeight);
			}
		});
		ro.observe(el);
		return () => ro.disconnect();
	}, [ref]);

	return height;
}
